import React, { useContext, useEffect, useState } from "react";
import styles from './ProductPage.module.css';
import generalStyles from '../generalAssets/GeneralAssets.module.css';
import buttonStyles from '../../buttons/Buttons.module.css';
import { createSearchParams, Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { sortAlphaNumeric } from "../../../functions/SortFunctions";
import ImgCarousel from "./ImgCarousel";
import ProductCard from "./ProductCard";
import ProductCardV2 from "./ProductCardV2";
import { QuoteBasketContext } from "../../providers/QuoteBasketProvider";
import { LoggedInContext } from "../../providers/LoggedInContext";

export default function ProductPage(){

    var alertTimeout = '';

    const { groupCode , id } = useParams();

    const { user , setLoading } = useContext(LoggedInContext);

    const [productVariants,setProductVariants] = useState([]);
    const [categoryProducts,setCategoryProducts] = useState([]);
    const [productGroups,setProductGroups] = useState([]);
    const [currVariant,setCurrVariant] = useState({});

    const [addQuantity,setAddQuantity] = useState(1);

    const [addedObject,setAddedObject] = useState({id: 0});
    const [showMessage,setShowMessage] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        getCatalogueItems();
        setCurrVariant((prev) => {
            console.log('cleared');
            return {
                ...prev,
                imgUrl: ''
            }
        })
    },[id,groupCode]);

    useEffect(() => {
        if(currVariant.category){
            getCatalogueItemsCategory();
        }
    },[currVariant.category]);

    useEffect(() => {
        if(productVariants.length > 0){
            const thisVariantIndex = productVariants.findIndex((variant) => variant.id === Number(id));
            if(thisVariantIndex > -1){
                setCurrVariant(productVariants[thisVariantIndex]);
                setAddQuantity(1)
            }
        }
    },[productVariants,id]);


    const displayAdded = () => {
        window.clearTimeout(alertTimeout);
        setShowMessage(true);
        alertTimeout = setTimeout(() => {
            setShowMessage(false);
            setAddedObject({id: 0});
        }, 5000);
    }

    const getCatalogueItems = async () => {
        setLoading(true);
        const headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        fetch(`${process.env.REACT_APP_STATUS === 'PRODUCTION'? process.env.REACT_APP_PRODUCTION_BACKEND : process.env.REACT_APP_BACKEND}/catalogue/groupCode/${groupCode}/8`,{
            method: 'GET',
            headers: headers,
            credentials: 'include',
        })
        .then((res) => res.text())
        .then((data) => {
            const recObj = JSON.parse(data);
            setProductVariants(recObj.catalogueItems);
            setLoading(false);
        })
        .catch((err) => console.log(err));
    }

    const getCatalogueItemsCategory = async () => {
        console.log(currVariant);
        const headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        fetch(`${process.env.REACT_APP_STATUS === 'PRODUCTION'? process.env.REACT_APP_PRODUCTION_BACKEND : process.env.REACT_APP_BACKEND}/catalogue/category/${currVariant.category}/8`,{
            method: 'GET',
            headers: headers,
            credentials: 'include',
        })
        .then((res) => res.text())
        .then((data) => {
            const recObj = JSON.parse(data);
            console.log('receivedFromCategory',recObj);
            setCategoryProducts(recObj.catalogueItems);
            createProductListings(recObj.catalogueItems);
        })
        .catch((err) => console.log(err));
    }

    const createProductListings = (array) => {
        console.log(array);
        const uniqueProductGroups = [...new Set(array.map((product) => product.productGroupCode ))].map((productGroupCode) => {
            const filterEntries = array.filter((product) => product.productGroupCode === productGroupCode);
            const imgArray = filterEntries.filter((product) => product.imgUrl !== null && product.imgUrl !== '').map((product) => product.imgUrl).join(',').split(',').map((url) => url.replace('/s/','/shared/static/'));
            // console.log(filterEntries.filter((product) => product.imgUrl !== null && product.imgUrl !== ''));
            return {
                productGroupCode,
                productGroupName: filterEntries[0].productGroupName,
                category: filterEntries[0].category,
                lowestCost: Math.min(...filterEntries.map((product) => Number(product.stratelaSalesCost))),
                imgArray: imgArray,
                noVariations: filterEntries.length,
                description: filterEntries[0].description,
                sortedProductVariations: filterEntries.sort(sortAlphaNumeric('code','asc','alpha'))
            }
        });
        setProductGroups(uniqueProductGroups.sort(sortAlphaNumeric('productGroupName','asc','alpha')).sort(sortAlphaNumeric('category','asc','alpha')));
    }

    const backToCatalogue = () => {
        navigate('/hiq/catalogue');
    }

    const increaseQty = () => {
        setAddQuantity((prev) => {
            return prev+1;
        });
    }

    const decreaseQty = () => {
        setAddQuantity((prev) => {
            if(prev > 1){
                return prev - 1;
            } else {
                return prev;
            }
        });
    }

    const select = (e) => {
        e.target.select();
    }

    const handleChange = (e) => {
        const value = e.target.value;
        setAddQuantity(() => {
            if(value > 0){
                return value;
            }
        })
    }

    const handleBlur = (e) => {
        const value = e.target.value;
        setAddQuantity(() => {
            if(value > 0){
                return Math.ceil(value);
            }
        })
    }

    const option = (productGroupObj) => {

        const handleClick = () => {
            if(productGroupObj.id !== Number(id)){
                navigate(`/hiq/catalogue/${groupCode}/${productGroupObj.id}`)
            }
        }

        return (
            <div className={`${styles.cardDetails} ${Number(id) === productGroupObj.id? styles.selected : ''}`} onClick={handleClick}>
                <div className={styles.imgContainer}>
                    <div className={styles.imgDiv} style={{transition: '0.3s', backgroundImage: `url(${productGroupObj.imgUrl? productGroupObj.imgUrl.split(',')[0].replace('/s/','/shared/static/') : ''})`}}></div>
                </div>
                <div className={styles.info}>
                    <p className={styles.code}>{productGroupObj.code}</p>
                    <p className={styles.code}>{productGroupObj.productVariant}</p>
                    <p className={styles.code}>£{productGroupObj.stratelaSalesCost? productGroupObj.stratelaSalesCost.toFixed(2) : ''}</p>
                </div>
            </div>
        )
    }

    const params = new URLSearchParams();
    params.set('filterName',JSON.stringify([currVariant.category]));

    return (
        <div className={generalStyles.container}>
            <div className={styles.navigation}>
                <Link to="/hiq/catalogue">Back to Catalogue</Link>
                <Link to={{ pathname: `/hiq/catalogue`, search:`?${params.toString()}`}}>{currVariant.category}</Link>
            </div>
            <div className={styles.container}>
                <div className={styles.imgSection}>
                    <ImgCarousel imgArray={currVariant.imgUrl? currVariant.imgUrl.split(',') : []} />
                </div>
                <div className={styles.infoSection}>
                    <div className={styles.titleSection}>
                        <p className={styles.code}>{currVariant.code}</p>
                        <h1>{currVariant.name}</h1>
                        <p className={styles.code}>{currVariant.productVariant}</p>
                        {/* <p className={styles.code}>{currVariant.category}</p> */}
                    </div>
                    <div className={styles.imgSectionSmall}>
                        <ImgCarousel imgArray={currVariant.imgUrl? currVariant.imgUrl.split(',') : []} />
                    </div>
                    <div className={styles.bottomSection}>
                        <div>
                            <div className={styles.costSection}>
                                <h3>£{currVariant.stratelaSalesCost? currVariant.stratelaSalesCost.toFixed(2) : ''}<span> ex VAT</span></h3>
                            </div>
                        </div>
                        <div className={styles.descriptionSection}>
                            {/* <h2 className={styles.code}>Description</h2> */}
                            <p className={styles.code}>{currVariant.description}</p>
                            <p className={styles.code}>{currVariant.dims}</p>
                        </div>
                    </div>
                    <div className={styles.optionSection}>
                        {productVariants.sort(sortAlphaNumeric('code','asc','alpha')).map((variant) => option(variant))}
                    </div>
                </div>
            </div>
            <div className={styles.recomendedSection}>
                <h4>More {currVariant.category}</h4>
                <div className={styles.productCardContainer}>
                    {productGroups.filter((group) => group.productGroupCode !== currVariant.productGroupCode).map((group) => <ProductCardV2 productGroupObj={group}/>)}
                </div>
            </div>
        </div>
    )
}